import request from '@/utils/request'

/**
 * 获取所有分类
 * @param data 不需要传递
 * @returns {*}
 */
export function getType(data) {
    return request({
        url: '/type-info/getAllType',
        method: 'post',
        data
    })
}

/**
 * 根据分类id获取商品
 * @param data
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getCommodityById(data) {
    return request({
        url: '/commodity-info/selectCommodityByType',
        method: 'post',
        data
    })
}

/**
 * 获取所有国家销售
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getCountrySales() {
    return request({
        url: '/country-sale-info/getAllCountrySale',
        method: 'post'
    })
}

/**
 * 获取所有团队
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getAllTeam() {
    return request({
        url: '/team-picture-info/getAllTeamPicture',
        method: 'post',
    })
}

/**
 * 获取全部小分类
 * @param params
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function selectChildType(params) {
    return request({
        url: '/child-type-info/selectChildTypeByTypeId',
        method: 'post',
        params
    })
}

/**
 * 获取商品数据
 * @param params
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getProductData(params) {
    return request({
        url: '/commodity-info/pageGetCommodityByNameIn2Type',
        method: 'post',
        params
    })
}

/**
 * 获取联系方式和团队的图片配置
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getImgOptions() {
    return request({
        url: '/foot-picture-info/selectAllFootPicture',
        method: 'post',
    })
}

/**
 * 添加用户反馈信息
 * @param params 相应的反馈数据
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function addContact(params) {
    return request({
        url: '/contact-info/addContactInfo',
        method: 'post',
        params
    })
}

/**
 * 获取轮播图
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getSwiperPictures() {
    return request({
        url: '/home-page-info/selectAll',
        method: 'post',
    })
}

/**
 * 获取OEM流程图片
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getProcessPictures() {
    return request({
        url: '/picture/selectAll',
        method: 'post',
    })
}

/**
 * 获取产品列表
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getProductList() {
    return request({
        url: '/productInfo/list',
        method: 'post',
    })
}

/**
 * 获取公司介绍信息
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getIntroductionInfo() {
    return request({
        url: '/introduction-info/list',
        method: 'post',
    })
}

/**
 * 获取优势信息
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getAdvantageInfo() {
    return request({
        url: '/advantage-info/list',
        method: 'post',
    })
}

/**
 * 获取资质认证信息
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getCertificationInfo() {
    return request({
        url: '/certification-info/list',
        method: 'post',
    })
}

/**
 * 获取公司简介信息
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getProfileInfo() {
    return request({
        url: '/profile-info/list',
        method: 'post',
    })
}

/**
 * 获取OEM流程背景图
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getFlowPicture() {
    return request({
        url: '/picture/selectByflow',
        method: 'post',
    })
}

/**
 * 获取合作伙伴信息
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getBroInfo() {
    return request({
        url: '/bro-info/list',
        method: 'post',
    })
}

/**
 * 根据名称获取证书PDF
 * @param name 证书名称
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export function getCertificatePdfByName(name) {
    return request({
        url: '/certificatePdfInfo/getByName',
        method: 'post',
        params: { name }
    })
}
